import React from 'react';
import styles from './Loading.module.scss';

const Loading: React.FC = () => (
  <div className={styles.loading}>
    <svg className={styles.circular} viewBox="0 0 50 50">
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth="1"
        strokeLinecap="round"
      />
    </svg>
  </div>
);

export default Loading;
